/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';
// @ts-ignore
import type { Discount } from './Discount';
// @ts-ignore
import {
// @ts-ignore
    DiscountFromJSON,
// @ts-ignore
    DiscountFromJSONTyped,
// @ts-ignore
    DiscountToJSON,
} from './Discount';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';
// @ts-ignore
import type { TimeWindow } from './TimeWindow';
// @ts-ignore
import {
// @ts-ignore
    TimeWindowFromJSON,
// @ts-ignore
    TimeWindowFromJSONTyped,
// @ts-ignore
    TimeWindowToJSON,
} from './TimeWindow';

/**
 * 
 * @export
 * @interface PromotionUpdateRequest
 */
export interface PromotionUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PromotionUpdateRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionUpdateRequest
     */
    name: string;
    /**
     * 
     * @type {TimeWindow}
     * @memberof PromotionUpdateRequest
     */
    effectivePeriod?: TimeWindow;
    /**
     * 
     * @type {Array<Discount>}
     * @memberof PromotionUpdateRequest
     */
    discounts: Array<Discount>;
    /**
     * 
     * @type {string}
     * @memberof PromotionUpdateRequest
     */
    currencyCode: string;
    /**
     * 
     * @type {Amount}
     * @memberof PromotionUpdateRequest
     */
    minimumAmount?: Amount;
    /**
     * 
     * @type {number}
     * @memberof PromotionUpdateRequest
     */
    minimumQuantity: number;
    /**
     * 
     * @type {string}
     * @memberof PromotionUpdateRequest
     */
    supplierId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromotionUpdateRequest
     */
    retailerIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromotionUpdateRequest
     */
    storeIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PromotionUpdateRequest
     */
    productCategoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionUpdateRequest
     */
    productListId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PromotionUpdateRequest
     */
    skuIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PromotionUpdateRequest
     */
    allProducts?: boolean;
    /**
     * 
     * @type {Status}
     * @memberof PromotionUpdateRequest
     */
    status: Status;
}

/**
 * Check if a given object implements the PromotionUpdateRequest interface.
 */
// @ts-ignore
export function instanceOfPromotionUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "discounts" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "minimumQuantity" in value;
    isInstance = isInstance && "supplierId" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

// @ts-ignore
export function PromotionUpdateRequestFromJSON(json: any): PromotionUpdateRequest {
    return PromotionUpdateRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function PromotionUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionUpdateRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'effectivePeriod': !exists(json, 'effective_period') ? undefined : TimeWindowFromJSON(json['effective_period']),
        'discounts': ((json['discounts'] as Array<any>).map(DiscountFromJSON)),
        'currencyCode': json['currency_code'],
        'minimumAmount': !exists(json, 'minimum_amount') ? undefined : AmountFromJSON(json['minimum_amount']),
        'minimumQuantity': json['minimum_quantity'],
        'supplierId': json['supplier_id'],
        'retailerIds': !exists(json, 'retailer_ids') ? undefined : json['retailer_ids'],
        'storeIds': !exists(json, 'store_ids') ? undefined : json['store_ids'],
        'productCategoryId': !exists(json, 'product_category_id') ? undefined : json['product_category_id'],
        'productListId': !exists(json, 'product_list_id') ? undefined : json['product_list_id'],
        'skuIds': !exists(json, 'sku_ids') ? undefined : json['sku_ids'],
        'allProducts': !exists(json, 'all_products') ? undefined : json['all_products'],
        'status': StatusFromJSON(json['status']),
    };
}

// @ts-ignore
export function PromotionUpdateRequestToJSON(value?: PromotionUpdateRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'effective_period': TimeWindowToJSON(value.effectivePeriod),
        'discounts': ((value.discounts as Array<any>).map(DiscountToJSON)),
        'currency_code': value.currencyCode,
        'minimum_amount': AmountToJSON(value.minimumAmount),
        'minimum_quantity': value.minimumQuantity,
        'supplier_id': value.supplierId,
        'retailer_ids': value.retailerIds,
        'store_ids': value.storeIds,
        'product_category_id': value.productCategoryId,
        'product_list_id': value.productListId,
        'sku_ids': value.skuIds,
        'all_products': value.allProducts,
        'status': StatusToJSON(value.status),
    };
}

